import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class StorageService {

  store(value: string, key: string): void {
    const appKey: string = this.normalizeString(environment.appname) + '__' + key;
    localStorage.setItem(appKey, value);
  }

  restore(key: string): string {
    const appKey: string = this.normalizeString(environment.appname) + '__' + key;
    return localStorage.getItem(appKey);
  }

  storeObject(value: any, key: string) {
    const appKey: string = this.normalizeString(environment.appname) + '__' + key;
    localStorage.setItem(appKey, JSON.stringify(value));
  }

  restoreObject(key: string): any {
    const appKey: string = this.normalizeString(environment.appname) + '__' + key;
    return JSON.parse(localStorage.getItem(appKey));
  }
  clear(key: string): void {
    const appKey: string = this.normalizeString(environment.appname) + '__' + key;
    return localStorage.removeItem(appKey)
  }

  private normalizeString(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\ /g, '_');
  }

  clearKeysWithDoubleUnderscore(): void {
    const now = new Date();
    const exceptions = ['__home_config'];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.includes('__')) continue;

      // Mantém as exceções
      if (exceptions.includes(key)) continue;

      const value = localStorage.getItem(key);

      // Verifica se é um timestamp usado pelo reminder
      if (key.includes('-remimber-app-data') && value) {
        const savedDate = new Date(parseInt(value));
        const expiresAt = new Date(savedDate);
        expiresAt.setDate(savedDate.getDate() + 7);

        if (now > expiresAt) {
          localStorage.removeItem(key);
        }

        continue;
      }

      // Remove todos os outros com '__' no nome
      localStorage.removeItem(key);
    }
  }
}
